import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    visibility: false,
    submit_btn_disable: false,
    upload_success_session: 0,
    upload_success_language: '',
    web_language: ''
  },
  mutations: {
    INIT_ADD_WEBSITE_DIALOG(state, payload) {
      state.visibility = true
      state.web_language = payload?.language ?? ''
    },
    RESET_ADD_WEBSITE_DIALOG(state) {
      state.visibility = false
      state.web_language = ''
    },
    SET_ADD_WEBSITE_DIALOG_SUBMIT_BTN_DISABLE(state, payload) {
      state.submit_btn_disable = payload
    },
    BUMP_ADD_WEBSITE_DIALOG_SUCCESS_SESSION(state, payload) {
      state.upload_success_language = payload?.language ?? ''
      state.upload_success_session++
    },
    SET_ADD_WEBSITE_DIALOG_WEB_LANGUAGE(state, payload) {
      state.web_language = payload
    }
  },
  actions: {
    async addMrcWebsite({ commit, rootState }, payload) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.uploading', ''), loading: true })
        commit('SET_ADD_WEBSITE_DIALOG_SUBMIT_BTN_DISABLE', true)

        const form_data = new FormData()
        form_data.append('device_id', rootState.auth.selected_device)
        form_data.append('doc_type', 'web')
        form_data.append('language', payload.language)
        form_data.append('url', payload.url)

        const response = await api.addMrcDoc({ params: form_data })
        if (response.data.success) {
          commit('SET_SNACKBAR', {
            status: true,
            color: 'success',
            text: Vuetify.locale.t('$vuetify.__SnackBar.upload', Vuetify.locale.t('$vuetify.__General.file')),
            icon: 'check',
            timeout: '2000'
          })
          commit('RESET_ADD_WEBSITE_DIALOG')
          commit('BUMP_ADD_WEBSITE_DIALOG_SUCCESS_SESSION', { language: payload.language })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_ADD_WEBSITE_DIALOG_SUBMIT_BTN_DISABLE', false)
      }
    }
  }
}
